import { produce } from 'immer';
import { getHtmlTextContent } from '../../utils/htmlUtils';
import { ADD_MESSAGE_BOX, ADD_MESSAGE_BOX_FROM_INBOUND, CLEAR_MESSAGE_BOXES_STATE, CLOSE_CURRENT_MESSAGE_BOX } from '../actions/messageBoxesActions';
const initialState = {
    messageBoxes: []
};
const messageBoxesReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_MESSAGE_BOXES_STATE: {
                return initialState;
            }
            case ADD_MESSAGE_BOX: {
                draft.messageBoxes.push(action.payload);
                break;
            }
            case ADD_MESSAGE_BOX_FROM_INBOUND: {
                let { title, html } = action.payload;
                if (!title && html) {
                    // For some short content message boxes, only the message is provided, so show it in the title.
                    title = getHtmlTextContent(html) || ''; // in case HTML tags are in the message box body, strip them for use in the title
                    html = ''; // don't show message box body now (it would be redundant)
                }
                if (title || html) {
                    // make sure some content exists
                    draft.messageBoxes.push({
                        type: 'inbound',
                        title,
                        html
                    });
                }
                break;
            }
            case CLOSE_CURRENT_MESSAGE_BOX: {
                if (draft.messageBoxes.length) {
                    draft.messageBoxes = draft.messageBoxes.slice(1);
                }
                break;
            }
        }
    });
};
export default messageBoxesReducer;
